<template>
  <div class="homepage-logo-wrapper">
    <img @click="this.$router.push('/')" class="homepage-logo img-fluid" src="../assets/logo.webp" alt="Home"
      style="margin-left: 8rem;">
    <!-- <div class="d-flex downloadLinks">
      <h3 class="mx-4" style="margin-top: 0.5rem;">Download Links (Outdated, currently working on a rework):
      </h3>
      <a href="https://linktr.ee/aotchron" target="_blank">
        <img height="48" src="../assets/googledrive-icon-logo.png" alt="Link 1">
      </a>
      <a href="https://linktr.ee/aotchr0n" target="_blank">
        <img height="48" src="../assets/mega-icon-logo.png" alt="Link 2">
      </a>
    </div> -->
  </div>
  <div class="container-fluid mt-5 mobileSpacing">
    <div v-for="arc in arcs" :key="arc.name" class="mt-5">
      <h3 class="mx-4">{{ arc.name }}</h3>
      <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner">
          <div v-for="(episode, index) in arc.episodes" :key="index" class="carousel-item">
            <div class="card"
              :class="openCard != false && openCard == index + 1 && arcName == arc.name ? 'expanded' : 'cardClosed'">
              <div class="episodeNumber">{{ episode.number }}</div>

              <div class="title">{{ episode.title }}</div>
              <div class="img-wrapper">
                <div class="durationWrapper">
                  <div class="duration">{{ episode.duration }}</div>
                  <img @mouseenter="hoverImage = { index: index + 1, arcName: arc.name }" @mouseleave="hoverImage = null"
                    :style="{ filter: hoverImage && hoverImage.index == index + 1 && hoverImage.arcName == arc.name ? 'brightness(140%)' : 'none' }"
                    @click="expandCard(index + 1, arc.name)" :src="episode.thumbnail" class="d-block w-100" alt="..." />
                </div>
                <img @mouseenter="hoverImage = { index: index + 1, arcName: arc.name }" @mouseleave="hoverImage = null"
                  :style="{ filter: hoverImage && hoverImage.index == index + 1 && hoverImage.arcName == arc.name ? 'brightness(140%)' : 'none' }"
                  @click="expandCard(index + 1, arc.name)" :src="episode.thumbnail" class="d-block w-100" alt="..." />
              </div>
              <div v-if="openCard != false && openCard == index + 1 && arcName == arc.name" class="card-body">
                <p class="card-text">{{ episode.description }}</p>
                <div class="d-flex justify-content-between">
                  <div v-if="episode.linkSub">
                    <a :href="episode.linkSub" target="_blank">
                      <i class="fa-solid fa-desktop"></i> Watch Sub
                    </a>
                  </div>
                  <div v-if="episode.linkDub">
                    <a :href="episode.linkDub" target="_blank">
                      <i class="fa-solid fa-desktop"></i> Watch Dub
                    </a>
                  </div>
                    <!-- <div v-if="episode.linkSub" @click="openDropDown(index, 1)" class="myBtn">
                      <i class="fa-solid fa-download"></i> Download Torrent
                    </div>
                    <div class="dropDowner" :id="'dropDowner1' + index">
                      <a v-if="episode.linkSub" :href="'https://aotchron.000webhostapp.com/?filename=' + episode.linkSub"
                        class="myBtn"><i class="fa-solid fa-download"></i> English Sub</a>
                      <br>
                      <a class="myBtn" v-if="episode.linkDub" :href="require('../assets/' + episode.linkDub)"
                        :download="episode.linkDub"><i class="fa-solid fa-download"></i> English Dub</a>
                    </div> 
                  </div> -->

                  <!-- <div v-if="episode.linkSub" @click="openDropDown(index, 2)" class="myBtn">
                    <i class="fa-solid fa-magnet"></i> Copy Magnet Link
                  </div>
                  <div class="dropDowner2" :id="'dropDowner2' + index">
                    <a v-if="episode.linkSubMagnet" @click="copyToClipboard(episode.linkSubMagnet)" class="myBtn"><i
                        class="fa-solid fa-magnet"></i> English Sub</a>
                    <br>
                    <a class="myBtn" v-if="episode.linkDubMagnet" @click="copyToClipboard(episode.linkDubMagnet)"><i
                        class="fa-solid fa-magnet"></i> English Dub</a>
                  </div> -->
                </div>
                <hr v-if="episode.infoText" class="card-divider">
                    <div v-if="episode.infoText">
                      <b>{{ episode.infoText }}</b>
                    </div>
                <hr v-if="episode.dubRelease || episode.subRelease" class="card-divider">
                    <div v-if="episode.subRelease">
                      Sub release date: <b>{{ episode.subRelease }}</b>
                    </div>
                    <div v-if="episode.dubRelease">
                      Dub release date: <b>{{ episode.dubRelease }}</b>
                    </div>
                <hr class="card-divider">
                <div v-if="episode.years != ''">
                  Timeline: <br /><b>{{ episode.years }}</b> <br />
                </div>
                <div>
                  Number of Episodes used: <b>{{ episode.noOfEpisodesUsed }}</b> <br />
                  Episodes used: <br /><b>{{ episode.episodesUsed }}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Transition name="fade">
    <p v-if="showMessage" class="copyMessage">Copied link to clipboard</p>
  </Transition>
</template>

<script>
import copy from 'copy-to-clipboard';
import * as arcs from "@/assets/arcs.json"

export default {
  data() {
    return {
      hoverImage: null,
      hoverCardIndex: null,
      hoverArcName: null,
      hover: false,
      openCard: false,
      arcName: '',
      showMessage: false,
      lastDowner: 0,
      arcs: [],
      openCard: false,
      arcName: ""
    };
  },
  mounted() {
    this.arcs = arcs.arcs
  },
  methods:
  {
    hoverCard(index, arcName) {
      this.hoverCardIndex = index;
      this.hoverArcName = arcName;
    },
    unhoverCard() {
      this.hoverCardIndex = null;
      this.hoverArcName = null;
    },
    expandCard(index, name) {
      if (this.openCard === index && this.arcName === name) {
        this.openCard = false;
        this.arcName = "";
      } else {
        this.openCard = index;
        this.arcName = name;
      }
    },
    openDropDown(index, downerId) {
      if (this.lastDowner && document.getElementById(this.lastDowner) && "dropDowner" + downerId + index != this.lastDowner) {
        document.getElementById(this.lastDowner).style.display = "none"
      }

      let element = document.getElementById("dropDowner" + downerId + index)
      if (element.style.display == "none" || !element.style.display) {
        element.style.display = "block"
      } else {
        element.style.display = "none"
      }
      this.lastDowner = "dropDowner" + downerId + index
    },
    copyToClipboard(text) {
      this.showMessage = true
      setTimeout(() => {
        this.showMessage = false
      }, 1500);
      copy(text);
    },
  }
}
</script>

<style>
body {
  background-color: #0E0E0E;
}
</style>

<style scoped>
.homepage-logo-wrapper {
  position: absolute;
  display: block;
  z-index: 500;
  top: 0;
  right: 1rem;
}

.homepage-logo {
  cursor: pointer;
  max-height: 10rem;
}

.downloadLinks {
  margin-top: 5rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.copyMessage {
  position: fixed;
  z-index: 10;
  left: 50%;
  transform: translate(-50%);
  bottom: 5rem;
  color: white;
  font-weight: bold;
}

.cardClosed {
  background: transparent !important;
}

.dropDowner {
  position: absolute;
  margin-top: -5.2rem;
  width: 6.7rem;
  height: 3.7rem;
  background: linear-gradient(0deg, rgb(59, 59, 59) 0%, rgb(44, 44, 44), rgb(27, 27, 27) 100%);
  padding: 0.7rem;
  padding-top: 0.25rem;
  display: none;
}

.dropDowner2 {
  position: absolute;
  margin-top: -3rem;
  margin-left: 9.5rem;
  width: 6.7rem;
  height: 3.7rem;
  background: linear-gradient(0deg, rgb(59, 59, 59) 0%, rgb(44, 44, 44), rgb(27, 27, 27) 100%);
  padding: 0.7rem;
  padding-top: 0.25rem;
  display: none;
}

.myBtn {
  color: white;
  text-decoration: none;
  font-size: 0.8rem;
  padding-top: 1rem;
  white-space: nowrap;
}

.myBtn:hover {
  text-decoration: underline;
}

.card-divider {
  border-top: 1px solid rgba(255, 255, 255, 0.822);
  /* border-radius: 25%;
  opacity: 1; */
}

.btn {
  background: linear-gradient(90deg, rgb(27, 27, 27) 0%, rgb(44, 44, 44), rgb(59, 59, 59) 100%);
  border: 2px solid rgb(255, 255, 255);
  /* box-shadow: 0 0 6px rgba(255, 255, 255, 0.712); */
  font-weight: bold;
  color: white;
  padding: 0px 20px 0px 20px;
  margin-top: 5%;
  opacity: 0.8;
  transition: all 0.2s ease;
  width: 46%;
  font-size: 0.8rem;
  border-radius: 0;
}

.btn:hover {
  transform: scale(1.15);
}

.home-icon-container {
  position: relative;
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.divider {
  height: 1px;
  width: 200%;
  background-color: #ffffffad;
  flex-grow: 1;
  margin-top: 20px;
}

.episodeNumber {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  color: white;
  padding: 0.3rem 0.5rem 0.3rem 0.5rem;
  background: rgba(0, 0, 0, 0.4);
}

.duration {
  position: absolute;
  z-index: 2;
  bottom: 0;
  right: 0;
  color: white;
  padding: 0.3rem 0.5rem 0.3rem 0.5rem;
  background: rgba(0, 0, 0, 0.4);
}

.title {
  position: absolute;
  z-index: 2;
  bottom: 1;
  right: 1;
  color: white;
  padding: 0.3rem 0.5rem 0.3rem 0.5rem;
  background: rgba(0, 0, 0, 0.4);
}

.carousel {
  border-bottom: 1px solid white;
}

.carousel-inner {
  padding: 1em;
}

.carousel-item {
  max-width: 20rem;
}

.card {
  position: relative;
  z-index: 2;
  cursor: pointer;
  background: linear-gradient(0deg, rgb(27, 27, 27) 0%, rgb(44, 44, 44), rgb(59, 59, 59) 100%);
  margin: 0 0.5em;
  box-shadow: 2px 6px 8px 0 rgba(22, 22, 26, 0.18);
  border: none;
  height: 170px;
  transition: all 0.2s ease-out;
  margin-top: 15px;
}

.card.expanded {
  height: auto;
  transform: scale(1.11);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  padding-bottom: 2%;
}

.img-hover {
  box-shadow: 0 0 5px 2px rgba(0, 123, 255, 0.5);
}

.carousel-inner {
  overflow-x: scroll;
  padding: 1em;
}

.carousel-item {
  max-width: 20rem;
}

.carousel-item {
  margin-right: 0;
  flex: 0 0 33.333333%;
  display: block;
}

.carousel-inner {
  display: flex;
}

.durationWrapper {
  position: absolute;
  max-width: 100%;
  justify-content: center;
  align-items: center;
}

.card .img-wrapper {
  max-width: 100%;
  justify-content: center;
  align-items: center;
}

.card img {
  max-height: 100%;
}

@media only screen and (max-width: 600px) {
  .card .img-wrapper {
    min-width: 13em;
  }

  .title {
    font-size: 0.8rem;
    padding: 0.3rem 0.5rem 0.3rem 0.5rem;
  }

  .episodeNumber {
    font-size: 0.8rem;
  }
  .duration {
    font-size: 0.8rem;
  }
}

::-webkit-scrollbar {
  width: 1px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #0E0E0E;
}

::-webkit-scrollbar-thumb {
  background: rgb(255, 255, 255);
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #494949;
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

@media only screen and (max-width: 800px) {
  .homepage-logo-wrapper {
    position: absolute;
    display: flex;
    z-index: 500;
    top: 0;
    left: 1rem;
  }

  .homepage-logo {
    cursor: pointer;
    max-height: 10rem;
  }

  .downloadLinks {
    margin-top: 4rem;
  }

  .mobileSpacing {
    margin-top: 12rem !important;
  }
}

@media only screen and (max-width: 610px) {
  .homepage-logo-wrapper {
    position: absolute;
    display: block;
    z-index: 500;
    top: 0;
    left: 1rem;
  }

  .homepage-logo {
    cursor: pointer;
    max-height: 7.5rem;
  }

  .downloadLinks {
    margin-top: 1rem;
  }

  .downloadLinks>h3 {
    font-size: 1.1rem;
  }

  .downloadLinks>a>img {
    height: 30px !important;
  }

  .mobileSpacing {
    margin-top: 20rem !important;
  }
}
</style>
